export const domain = 'Product';

// action types
export const FETCH_ERROR = `${domain}/FETCH_ERROR`;
export const IS_FETCHING = `${domain}/IS_FETCHING`;
export const RECEIVE_PRODUCT = `${domain}/RECEIVE_PRODUCT`;
export const RECEIVE_PRODUCT_FAMILY = `${domain}/RECEIVE_PRODUCT_FAMILY`;
export const RECEIVE_PRODUCT_FAMILY_ON_DISPLAY = `${domain}/RECEIVE_PRODUCT_FAMILY_ON_DISPLAY`;
export const RECEIVE_PRODUCT_FAMILY_QUANTITY = `${domain}/RECEIVE_PRODUCT_FAMILY_QUANTITY`;
export const RECEIVE_PRODUCT_ON_DISPLAY = `${domain}/RECEIVE_PRODUCT_ON_DISPLAY`;
export const RECEIVE_PRODUCT_QUANTITY = `${domain}/RECEIVE_PRODUCT_QUANTITY`;
export const RECEIVE_PRODUCT_REVIEWS = `${domain}/RECEIVE_PRODUCT_REVIEWS`;
export const RECEIVE_RELATED_PRODUCTS = `${domain}/RECEIVE_RELATED_PRODUCTS`;
export const RECEIVE_PRODUCT_FAMILY_RELATED_PRODUCTS = `${domain}/RECEIVE_PRODUCT_FAMILY_RELATED_PRODUCTS`;
export const RECEIVE_PRODUCT_FAMILY_REVIEWS = `${domain}/RECEIVE_PRODUCT_FAMILY_REVIEWS`;
